import * as React from 'react'
import * as PopoverPrimitive from '@radix-ui/react-popover'

import { cn, createComponent } from '@lair-finance/util'

export const Popover = PopoverPrimitive.Root

export const PopoverTrigger = PopoverPrimitive.Trigger

export const PopoverPortal = PopoverPrimitive.Portal

export const PopoverClose = PopoverPrimitive.Close

export const PopoverOverlay = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'fixed inset-0 bg-[rgba(0,0,0,.50)] data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0',
      className,
    )}
    {...props}
  />
))
PopoverOverlay.displayName = 'PopoverOverlay'

export const PopoverContent = createComponent<
  React.ElementRef<typeof PopoverPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content> & {
    noStyle?: boolean
    preventCloseOnOutsideClick?: boolean
  }
>(
  ({ className, sideOffset = 4, noStyle, preventCloseOnOutsideClick, ...props }, ref) => (
    <PopoverPrimitive.Content
      ref={ref}
      sideOffset={sideOffset}
      onInteractOutside={event => {
        if (preventCloseOnOutsideClick) {
          event.preventDefault()
        }
      }}
      className={cn(
        'z-50 outline-none overflow-hidden animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2',
        {
          'rounded-[8px] border border-greyscale-400 bg-greyscale-500 shadow-[0_0_12px_0_rgba(30,31,35,.50)] p-[15px] typo-caption-2 text-greyscale-200 [&>a]:text-palette-sky [&>a]:underline [&>strong]:font-normal [&>strong]:text-primary-500 ':
            !noStyle,
        },
        className,
      )}
      {...props}
    />
  ),
  'PopoverContent',
)
